import { render, staticRenderFns } from "./ContentFooter.vue?vue&type=template&id=52e56508&scoped=true"
import script from "./ContentFooter.vue?vue&type=script&lang=js"
export * from "./ContentFooter.vue?vue&type=script&lang=js"
import style0 from "./ContentFooter.vue?vue&type=style&index=0&id=52e56508&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e56508",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52e56508')) {
      api.createRecord('52e56508', component.options)
    } else {
      api.reload('52e56508', component.options)
    }
    module.hot.accept("./ContentFooter.vue?vue&type=template&id=52e56508&scoped=true", function () {
      api.rerender('52e56508', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/ContentFooter.vue"
export default component.exports